/**
 * Load riskified.
 * @param {string} id - session id.
 * @param {string} domain - domain.
 */
export function riskifiedLoad(id: string, domain = 'www.glassesusa.com') {
    const url = `${
        document.location.protocol === 'https:' ? 'https://' : 'http://'
    }beacon.riskified.com?shop=${domain}&sid=${id}`;
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = url;
    const element = document.getElementsByTagName('script')[0];
    if (element && element.parentNode) element.parentNode.insertBefore(script, element);
}
